export const gradeData = [{
    name: '短期班二年级第一讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901220024/index.html?cocos=1.7.2 '
  },
  {
    name: '短期班二年级第二讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901220025/index.html?cocos=1.7.2 '
  },
  {
    name: '短期班二年级第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901300001/index.html?cocos=1.7.2'
  },

  {
    name: '短期班三年级第一讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901220014/index.html?cocos=1.7.2 '
  },
  {
    name: '短期班三年级第二讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901220022/index.html?cocos=1.7.2 '
  },
  {
    name: '短期班三年级第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901310002/index.html?cocos=1.7.2'
  },
  {
    name: '短期班一年级第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901260001/index.html?cocos=1.7.3'
  },


  {
    name: '寒假大班第一讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901190001/index.html?cocos=1.7.3'
  },
  {
    name: '寒假大班第二讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901170014/index.html?cocos=1.7.3'
  },
  {
    name: '寒假大班第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901180003/index.html?cocos=1.7.3'
  },
  {
    name: '寒假大班第四讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901170015/index.html?cocos=1.7.3'
  },
  {
    name: '寒假大班第五讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901180001/index.html?cocos=1.7.3'
  },
  {
    name: '寒假大班第六讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901040013/index.html?cocos=1.7.3'
  },
  {
    name: '寒假大班第七讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901280003/index.html?cocos=1.7.3'
  },

  {
    name: '寒假一年级第一讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901150015/index.html?cocos=1.7.3'
  },
  {
    name: '寒假一年级第二讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901160013/index.html?cocos=1.7.3'
  },
  {
    name: '寒假一年级第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901170020/index.html?cocos=1.7.3'
  },
  {
    name: '寒假一年级第四讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201902010008/index.html?cocos=1.7.3 '
  },
  {
    name: '寒假一年级第五讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901040015/index.html?cocos=1.7.3'
  },
  {
    name: '寒假一年级第六讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901110004/index.html?cocos=1.7.3'
  },
  {
    name: '寒假一年级第七讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901170025/index.html?cocos=1.7.3'
  },

  {
    name: '寒假二年级第一讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901110002/index.html?cocos=1.7.2'
  },
  {
    name: '寒假二年级第二讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812120003/index.html?cocos=1.7.2'
  },
  {
    name: '寒假二年级第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812190006/index.html?cocos=1.7.2'
  },
  {
    name: '寒假二年级第四讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812180012/index.html?cocos=1.7.2'
  },
  {
    name: '寒假二年级第五讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812240009/index.html?cocos=1.7.2'
  },
  {
    name: '寒假二年级第六讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901150029/index.html?cocos=1.7.3'
  },
  {
    name: '寒假二年级第七讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901090005/index.html?cocos=1.7.2'
  },

  {
    name: '寒假三年级第一讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901150013/index.html?cocos=1.7.2'
  },
  {
    name: '寒假三年级第二讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812120005/index.html?cocos=1.7.2'
  },
  {
    name: '寒假三年级第三讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812190004/index.html?cocos=1.7.2'
  },
  {
    name: '寒假三年级第四讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201812180004/index.html?cocos=1.7.2'
  },
  {
    name: '寒假三年级第五讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901190002/index.html?cocos=1.7.2'
  },
  {
    name: '寒假三年级第六讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901220021/index.html?cocos=1.7.2'
  },
  {
    name: '寒假三年级第七讲：',
    url: ' https://zxxb-oss.haibian.com/nova/coursewares/201901110014/index.html?cocos=1.7.2'
  },
  {
    name: '春季班大班第一讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903040025/index.html?cocos=1.7.3'
  },
  {
    name: '春季班大班第二讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903150013/index.html?cocos=1.7.3'
  },
  {
    name: '春季班大班第三讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903220001/index.html?cocos=1.7.3'
  },
  {
    name: '春季班大班第四讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903270014/index.html?cocos=1.7.3'
  },


  {
    name: '春季班一年级第一讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201902280006/index.html?cocos=1.7.3 '
  },
  {
    name: '春季班一年级第二讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903070012/index.html?cocos=1.7.3'
  },
  {
    name: '春季班一年级第三讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903140004/index.html?cocos=1.7.3'
  },
  {
    name: '春季班一年级第四讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903270017/index.html?cocos=1.7.3'
  },

  {
    name: '春季班二年级第一讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903020001/index.html?cocos=1.7.3'
  },
  {
    name: '春季班二年级第二讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903140001/index.html?cocos=1.7.3'
  },
  {
    name: '春季班二年级第三讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903200005/index.html?cocos=1.7.3'
  },
  {
    name: '春季班二年级第四讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903270016/index.html?cocos=1.7.3'
  },


  {
    name: '春季班三年级第一讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903130012/index.html?cocos=1.7.3 '
  },
  {
    name: '春季班三年级第二讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903130013/index.html?cocos=1.7.3'
  },
  {
    name: '春季班三年级第三讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903200022/index.html?cocos=1.7.3'
  },
  {
    name: '春季班三年级第四讲：',
    url: 'https://zxxb-oss.haibian.com/nova/coursewares/201903270015/index.html?cocos=1.7.3'
  },

]



// WEBPACK FOOTER //
// ./src/components/index/grade.js